module.exports = __webpack_public_path__ + "static/Banner-health-logo-1-756edd1f6fe4797ba9f973d8dc4c5f8e.png";